import { ZodError } from "zod";

/*
 * An answer of the API outside its contract is a bug on one side (07 K-02); `docs/bff-prinzip.md`
 * §5.1 promises that it shows as an error. A page shows the failure, the guard goes on with the
 * last known session and the settings with their defaults (GP1); either way it must leave a trace:
 * `console.error` puts it in the console, and Faro's console instrumentation sends what the
 * console reports as an error, once the visitor agreed to "Statistik" (ADR-141). The query client
 * calls it for every failed read and change (`createPortalQueryClient`, PF4). The error comes
 * first, so Faro takes its type and stack; Zod's message names the paths and the expected types,
 * never the values received.
 */

/**
 * Reports `error` when it is an answer outside the contract (`ZodError`); any other failure, of
 * the network or of the API, passes without a word.
 *
 * @param error - what a read or change of `route` caught
 * @param route - the route of the catalogue whose answer it was (the first part of the query's
 *   key), named in the report
 * @returns whether it reported
 */
export function reportContractBreach(error: unknown, route: string): boolean {
  if (!(error instanceof ZodError)) return false;
  console.error(error, `[portal] the answer of route "${route}" is outside its contract`);
  return true;
}
